(() => {
  if (window.__bbSizeToCartBound) return;
  window.__bbSizeToCartBound = true;

  const pendingVariants = new Set();
  const sections = ["cart-drawer", "cart-icon-bubble"];

  function getCart() {
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }

  function parseVariantId(value) {
    if (!value) return "";
    if (/^\d+$/.test(value)) return value;
    try {
      const data = JSON.parse(value);
      return data && data.id ? String(data.id) : "";
    } catch (error) {
      return "";
    }
  }

  function addVariant(variantId) {
    if (!variantId || pendingVariants.has(variantId)) return;

    pendingVariants.add(variantId);

    fetch(Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) return;

        const cart = getCart();
        if (cart && typeof cart.renderContents === "function") {
          cart.renderContents(response);
        }
        if (typeof window.mountCartGwpCarousel === "function") {
          window.mountCartGwpCarousel();
        }
        document.dispatchEvent(new CustomEvent("countdown:restart"));
        document.dispatchEvent(new CustomEvent("mini-countdown:restart"));
        if (typeof nostojs === "function") {
          nostojs((api) => api.loadRecommendations());
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        pendingVariants.delete(variantId);
      });
  }

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest(".js-size-btn");
      if (!button) return;
      if (button.classList.contains("is-sold-out")) return;

      event.preventDefault();
      event.stopPropagation();
      addVariant(button.dataset.variantId);
    },
    true
  );

  document.addEventListener(
    "change",
    (event) => {
      const select = event.target.closest(".js-size-select");
      if (!select || select.classList.contains("js-gwp-size-select")) return;

      const variantId = parseVariantId(select.value);
      if (!variantId) return;

      addVariant(variantId);
      select.selectedIndex = 0;
    },
    true
  );
})();
